import { Component, ElementRef, OnInit } from '@angular/core';
import { PageBase, LocationInfo } from 't4core';
import { DialogService } from '../../../../t4common';

@Component({
  selector: 'SupportDashboard',
  styleUrls: ['./SupportDashboard.css'],
  templateUrl: './SupportDashboard.html',
})
export class SupportDashboardComponent extends PageBase implements OnInit {
  public location: LocationInfo;
    

    constructor(el: ElementRef, private dialogSvc: DialogService) {
      super(el, "Support");
    }

  async ngOnInit() {
    this.location = await this.Api.get<LocationInfo>("Location/GetLocationInfo", { id: this.Settings.clientSettings.RentalLocationId });
  }

    public goto(title: string) {
        this.UI.scrollToAnchor(title);
  }

  public sendMessage() {
    this.dialogSvc.sendMessage();
  }
}
